import { FC } from "react";
import * as React from "react";
import LoadingButton from "@ebsco-ui/loading-button";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Variant } from "../enum";
import { useDropdownContext } from "../dropdown-context";
import DropdownIcon from "../dropdown-icon";

export type DropdownToggleProps = React.HTMLProps<HTMLButtonElement>;

const DropdownToggle: FC<DropdownToggleProps> = ({ ...rest }) => {
  const {
    getBlocksWith,
    getToggleButtonProps,
    placeholder,
    selectedItem,
    variant,
    isLoading,
    announceLoadingStart,
    announceLoadingEnd,
    loadingPlaceholder,
    isMultiselect,
  } = useDropdownContext();

  if (!getToggleButtonProps) {
    throw new Error(
      "Dropdown.Toggle component requires getToggleButtonProps to be defined",
    );
  }

  const defaultButtonLabel =
    (!isMultiselect && selectedItem && selectedItem.label) || placeholder;

  // Use placeholder to provide the default styling and dropdown indicator.
  const placeholderButtonLabel =
    variant === Variant.MENUBUTTON ? placeholder : defaultButtonLabel;

  return (
    <LoadingButton
      isLoading={isLoading}
      loadingPlaceholder={loadingPlaceholder || placeholderButtonLabel}
      announceLoadingStart={announceLoadingStart}
      announceLoadingEnd={announceLoadingEnd}
      type="button"
      {...getToggleButtonProps({ ...rest })}
    >
      <span className={getBlocksWith("__toggle-button-label")}>
        {placeholderButtonLabel}
      </span>
      <DropdownIcon
        className={getBlocksWith("__dropdown-indicator")}
        icon={faAngleDown as IconProp}
      />
    </LoadingButton>
  );
};

export default DropdownToggle;
